// Centralized cookie-consent storage (Phase 2.6)
// Returns { functional, analytics, marketing } booleans.

const KEY = "cookie_consent";

export function getConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return {
      functional: !!parsed.functional,
      analytics: !!parsed.analytics,
      marketing: !!parsed.marketing,
    };
  } catch {
    return null;
  }
}

export function setConsent(consent) {
  const clean = {
    functional: !!consent.functional,
    analytics: !!consent.analytics,
    marketing: !!consent.marketing,
    _ts: Date.now(),
  };
  localStorage.setItem(KEY, JSON.stringify(clean));
  window.dispatchEvent(new CustomEvent("mid2bid:consent", { detail: clean }));
  return clean;
}

export function clearConsent() {
  localStorage.removeItem(KEY);
}
